"use strict";
/* eslint max-lines-per-function:"off", prefer-rest-params:"off", max-params:"off", sonarjs/cognitive-complexity:"off", init-declarations:"off" */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.octoLogger = exports.logger = exports.createLogger = exports.revertLoggerContext = exports.switchLoggerContext = exports.getLoggerContext = exports.createScopeEntry = exports.createLogEntry = exports.isLogEntry = void 0;
var output_1 = require("../output/output");
var utils_1 = require("../utils/utils");
var logger_types_1 = require("./logger.types");
var time = new Date();
var cid = 0;
function isMeta(arg) {
    return arg && arg.length === 3 && arg[0] && arg[1] > 0 && arg[2] > 0;
}
function toMeta(arg) {
    return { file: arg[0], line: arg[1], col: arg[2] };
}
function isLogEntry(x) {
    return x && x.type !== undefined && x.level !== undefined;
}
exports.isLogEntry = isLogEntry;
function createEntry(type, level, badge, label, args) {
    var entry = Object.defineProperty({
        cid: ++cid,
        ts: 0,
        type: type,
        level: level,
        badge: badge,
        label: label,
        args: args,
        meta: null,
        entries: [],
    }, 'parent', {
        writable: true,
        enumerable: false,
        value: null,
    });
    return entry;
}
function createLogEntry(level, badge, label, args) {
    return createEntry(logger_types_1.ENTRY, level, badge, label, args);
}
exports.createLogEntry = createLogEntry;
function createScopeEntry(level, badge, label, args) {
    return createEntry(logger_types_1.SCOPE, level, badge, label, args);
}
exports.createScopeEntry = createScopeEntry;
var _activeContext = null;
function getLoggerContext() {
    return _activeContext;
}
exports.getLoggerContext = getLoggerContext;
function switchLoggerContext(ctx, scope) {
    if (ctx === null) {
        _activeContext = null;
        return null;
    }
    var prev_activeContext = _activeContext;
    var prev_scope = ctx.scope;
    var prev_scopeContext = ctx.scopeContext;
    var prev_scopeContextParent = null;
    _activeContext = ctx;
    ctx.scope = scope;
    if (ctx.scopeContext) {
        prev_scopeContextParent = ctx.scopeContext.parent;
        ctx.scopeContext.parent = scope.scope();
    }
    return {
        activeContext: prev_activeContext,
        ctx: ctx,
        scope: prev_scope,
        scopeContext: prev_scopeContext,
        scopeContextParent: prev_scopeContextParent,
    };
}
exports.switchLoggerContext = switchLoggerContext;
function revertLoggerContext(snapshot) {
    var ctx = snapshot.ctx, scopeContext = snapshot.scopeContext;
    ctx.scope = snapshot.scope;
    ctx.scopeContext = scopeContext;
    if (scopeContext) {
        scopeContext.parent = snapshot.scopeContextParent;
    }
    _activeContext = snapshot.activeContext;
}
exports.revertLoggerContext = revertLoggerContext;
function createLogger(options, factory) {
    var createCoreLogger = function (ctx) { return ({
        add: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var meta = isMeta(args[0]) ? toMeta(args.shift()) : null;
            var entry;
            if (isLogEntry(args[0])) {
                entry = args[0];
            }
            else {
                entry = createLogEntry('log', null, null, args);
            }
            if (meta !== null) {
                entry.meta = meta;
            }
            if (options.time) {
                entry.ts = (0, utils_1.now)();
            }
            var parent = ctx.parent;
            if (parent) {
                var length_1 = (entry.parent = parent).entries.push(entry);
                if (length_1 > options.storeLast) {
                    parent.entries.splice(0, 1);
                }
            }
            if (options.silent !== true && options.output) {
                options.output(entry);
            }
            return entry;
        },
    }); };
    var root = createScopeEntry('info', '🚧', '#root', [
        {
            time: time,
            created: new Date(),
        },
    ]);
    var _activeScopeContext = {
        logger: null,
        parent: root,
    };
    var logger = createCoreLogger(_activeScopeContext);
    var api = factory({
        createEntry: createLogEntry,
        logger: logger,
    });
    if (options.silent == null && typeof location !== 'undefined') {
        options.silent = !/^(about:|file:|https?:\/\/localhost\/)/.test("".concat(location));
    }
    if (options.time == null) {
        options.time = true;
    }
    if (options.storeLast == null) {
        options.storeLast = 1e3;
    }
    _activeScopeContext.logger = logger;
    // Reserved methods
    ['add', 'clear', 'scope', 'setup', 'entries', 'last', 'priny', 'm'].forEach(function (name) {
        if (api.hasOwnProperty(name)) {
            throw new Error("[octoLogger] \"".concat(name, "\" is a reserved identifier"));
        }
    });
    api.print = function () {
        var next = function (root) {
            root.printed = false;
            root.entries.forEach(function (entry) {
                entry.printed = false;
                if (options.output) {
                    options.output(entry);
                }
                if (entry.type === logger_types_1.SCOPE) {
                    next(entry);
                }
            });
        };
        next(root);
        // Close all groups
        if (options.output) {
            options.output(null);
        }
    };
    api.add = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logger.add.apply(logger, args);
    };
    api.clear = function () { return root.entries.splice(0, root.entries.length); };
    api.setup = function (optionsPatch) {
        options = __assign(__assign({}, options), optionsPatch);
    };
    api.entries = function () { return root.entries; };
    api.last = function () { return root.entries[root.entries.length - 1] || null; };
    api.scope = function scopeCreator(message, detail, executor) {
        var args = arguments;
        var meta = null;
        if (args.length === 0) {
            return this._scopeEntry;
        }
        if (isMeta(args[0])) {
            meta = toMeta(args[0]);
            message = args[1];
            detail = args[2];
            executor = args[3];
        }
        var hasDetail = args.length > 2;
        if (executor == null && typeof detail === 'function') {
            executor = detail;
            hasDetail = false;
        }
        var scopeArgs = [message];
        if (hasDetail) {
            scopeArgs.push(detail);
        }
        var scopeEntry = isLogEntry(message) ? message : createScopeEntry('info', null, null, scopeArgs);
        scopeEntry.meta = meta;
        _activeScopeContext.logger.add(scopeEntry);
        var logger = createCoreLogger({ parent: scopeEntry, logger: null });
        var scopeAPI = factory({
            createEntry: createLogEntry,
            logger: logger,
        });
        scopeAPI.add = function () {
            return logger.add.apply(logger, arguments);
        };
        scopeAPI.scope = scopeCreator;
        scopeAPI._scopeEntry = scopeEntry;
        // Переключаем scope
        if (typeof executor === 'function') {
            var prev_activeContext = _activeContext;
            var prev_parentEntry = _activeScopeContext.parent;
            var prev_parentLogger = _activeScopeContext.logger;
            _activeContext = {
                entry: scopeEntry,
                scope: scopeAPI,
                logger: logger,
                options: options,
                scopeContext: _activeScopeContext,
            };
            _activeScopeContext.parent = scopeEntry;
            executor(scopeAPI);
            _activeContext = prev_activeContext;
            _activeScopeContext.parent = prev_parentEntry;
            _activeScopeContext.logger = prev_parentLogger;
        }
        return scopeAPI;
    };
    return api;
}
exports.createLogger = createLogger;
var BADGES = {
    log: null,
    info: '❕ ',
    done: '✅ ',
    warn: '⚠️ ',
    error: '🛑 ',
    verbose: '🔎 ',
};
exports.logger = createLogger({
    output: (0, output_1.universalOutput)(),
}, function (_a) {
    var logger = _a.logger;
    return Object.keys(BADGES).reduce(function (api, level) {
        api[level] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            logger.add(createLogEntry(level, BADGES[level] || null, null, args));
        };
        return api;
    }, {});
});
exports.octoLogger = exports.logger;
//# sourceMappingURL=logger.js.map